<div>
  <a (click)="benutzerAnlegen()" class="mini-button" id="benutzerAnlegenButton"
     mat-button>Benutzer anlegen</a>

  <a (click)="benutzerBearbeiten()" [ngClass]="benutzerBearbeitungDisabled ? 'mini-button-disabled' : 'mini-button'"
     disabled="{{benutzerBearbeitungDisabled}}" id="benutzerBearbeitenButton"
     mat-button>Benutzer bearbeiten</a>

  <a (click)="benutzerLoeschen()" [ngClass]="benutzerBearbeitungDisabled ? 'mini-button-disabled' : 'mini-button'"
     disabled="{{benutzerBearbeitungDisabled}}" id="benutzerLoeschenButton"
     mat-button>Benutzer löschen</a>

  <a (click)="zurueck()" class="mini-button" id="zurueckButton"
     mat-button>Zurück</a>
</div>
<br>
<div class="center-table-container" *ngIf="showBenutzerliste">
  <div class="table-container">
    <!-- Test neues Module für Tabelle -->
    <p-table
      (onRowSelect)="onRowSelect($event)"
             (onRowUnselect)="onRowUnselect($event)"
             [(selection)]="selectedUser"
             [columns]="labelBenutzerTabelleHeader"
             [value]="benutzerliste"
             dataKey="bensl"
             selectionMode="single"
             [scrollable]="true"  scrollHeight="500px"
             [responsive]="true"
             [resizableColumns]="true"
             [paginator]="true" [rows]="15"
             [rowsPerPageOptions]="[15,25,50]"
    >
      <ng-template let-columns pTemplate="header">
        <tr>
          <th *ngFor="let labelBenutzerTabelle of labelBenutzerTabelleHeader">
            {{labelBenutzerTabelle.label}}
          </th>
        </tr>
      </ng-template>
      <ng-template let-rowData pTemplate="body">
        <tr [pSelectableRow]="rowData">
          <td>{{rowData.bensl}}</td>
          <td>{{rowData.rolle}}</td>
          <td>{{rowData.rights}}</td>
          <td>{{rowData.isAdmin}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="Benutzer Details" [(visible)]="displayDialog"
          [contentStyle]="{'overflow':'visible'}" [responsive]="true" showEffect="fade" ngModel="true"
          [style]="{width: '450px'}">
  <div class="ui-g ui-fluid" *ngIf="user">
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="bensl">Bensl</label>
      </div>
      <div *ngIf="newUser" class="ui-g-8">
        <input pInputText id="bensl" [(ngModel)]="user.bensl" minlength="5" maxlength="8" pattern="^[a-zA-Z][0-9a-zA-Z]*$"
                title="Bensl muss aus mindestens 5 Zeichen bestehen, erstes Zeichen ist ein Buchstabe"
               (keyup)="changeDone('bensl')"
               (keydown.enter)="changeDone('bensl')"
        />
      </div>
      <div *ngIf="!newUser" class="ui-g-8">
        {{user.bensl}}
      </div>

    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="rolle">Rolle</label>
      </div>
      <div class="ui-g-8">
        <p-dropdown id="rolle" [(ngModel)]="user.rolle" [options]="rollen" [style]="{'width':'100%'}"></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="rights">VTNR-Berechtigungen</label>
      </div>
      <div class="ui-g-8">
        <input style="width: 260px" id="rights" [(ngModel)]="user.rights" type="text" pattern="^(([1-9][0-9]{1,8}[*]{0,1}[,]{0,1})*|[*])$" required
              title="* oder durch Komma getrennte Liste von VTNRs (evtl. mit *)"
               (keyup)="changeDone('rights')"
               (keydown.enter)="changeDone('rights')"
        />
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="admin">Administrator</label>
      </div>
      <div class="ui-g-8">
        <p-dropdown id="admin" [(ngModel)]="user.isAdmin" [options]="adminAuswahl"
                    [style]="{'width':'100%'}"></p-dropdown>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" pButton (click)="abbrechen()" label="Abbrechen"></button>
      <button type="button" pButton (click)="benutzerSpeichern()"
              [disabled]="speichernDisabled"
              label="Speichern"></button>
    </div>
  </p-footer>
</p-dialog>
